<template>
  <div class="layouts-container">
    <Header />
    <div class="banner">
      <div class="banner-title flex">
        <!-- <h1>第九工场-设计服务</h1>
            <p>坚持做<span style="">『</span>吸引眼球，价格厚道』的好设计</p> -->
        <img :src="`${ossBaseUrl}/top_word.png`" style="width: 60rem; height: 13rem" />
      </div>
      <div class="todowns">
        <img :src="`${ossBaseUrl}/icon_down.png`" />
      </div>
      <div class="images" :style="{backgroundImage: `url(${ossBaseUrl}/swipe.jpg)`}"></div>
      <div class="overlay"></div>
    </div>
    <div class="teamwork">
      <h2>
        <img :src="`${ossBaseUrl}/icon27.jpg`" alt="" />合作优势<img
          :src="`${ossBaseUrl}/icon28.jpg`"
          alt=""
        />
      </h2>
      <h3>第九工场已服务过500多家优质企业，涵盖30多个行业</h3>
      <h3>与数家大型公司长期合作，锻造了一支能应对各类需求的设计团队</h3>

      <div class="table1">
        <div>
          <img
            :src="`${ossBaseUrl}/ui1.png`"
            style="
              height: 24.5rem;
              position: relative;
              top: -2rem;
              left: 2.5rem;
            "
            alt=""
          /><!-- width: 27rem; -->
          <p
            style="
              position: relative;
              top: -3rem;
              left: 1.6rem;
              font-size: 2.1rem;
            "
          >
            平面设计
          </p>
        </div>
        <div>
          <img
            :src="`${ossBaseUrl}/ui2.png`"
            style="height: 21.6rem"
            alt=""
          /><!-- width: 19rem; -->
          <p>视频制作</p>
        </div>
        <div>
          <img
            :src="`${ossBaseUrl}/ui3.png`"
            style="height: 21.5rem"
            alt=""
          /><!-- width: 22.5rem; -->
          <p>程序开发</p>
        </div>
        <div>
          <img
            :src="`${ossBaseUrl}/ui4.png`"
            style="height: 22.4rem; top: -1rem; position: relative"
            alt=""
          /><!-- width: 19rem; -->
          <p style="position: relative; top: -1rem">插画绘制</p>
        </div>
        <div>
          <img
            :src="`${ossBaseUrl}/ui5.png`"
            style="
              height: 22.6rem;
              top: -1rem;
              left: -2.9rem;
              position: relative;
            "
            alt=""
          /><!-- width: 33.5rem; -->
          <p style="position: relative; top: -1rem; left: -5rem">文案撰写</p>
        </div>
      </div>

      <div class="teamwork-more flex">
        <div class="more_td">
          <img class="icon" :src="`${ossBaseUrl}/ui6.jpg`" alt="" />
          <h4>合作无忧</h4>
          <p>草图不满意，可全额退款</p>
          <p>三年售后，免费微调</p>
        </div>
        <div class="more_td">
          <img class="img02" :src="`${ossBaseUrl}/ui9.jpg`" alt="" />
          <img class="icon" :src="`${ossBaseUrl}/ui7.jpg`" alt="" />
          <h4>品质保障</h4>
          <p>严格把控流程和品质</p>
          <p>超预期交付</p>
        </div>
        <div class="more_td">
          <img class="icon" :src="`${ossBaseUrl}/ui8.jpg`" alt="" />
          <h4>商用无忧</h4>
          <p>坚持原创</p>
          <p>无版权风险</p>
        </div>
      </div>
    </div>
    <div class="design">
      <h2>
        <img
          class="greendot"
          :src="`${ossBaseUrl}/greendot_left.png`"
          alt=""
        />特色设计<img
          class="greendot"
          :src="`${ossBaseUrl}/greendot_right.png`"
          alt=""
        />
      </h2>

      <div class="switch">
        <div
          class="tab"
          :class="{ active: itemIndex == item.index }"
          v-for="(item, index) in featureTab"
          :key="index"
          @click="switchFeatureTab(item.index)"
        >
          <div>{{ item.title }}</div>
        </div>
      </div>
      <div class="tabImg">
        <img
          style="width: 100%; height: 100%"
          v-show="itemIndex == 1"
          :src="`${ossBaseUrl}/tab.png`"
        />
        <img
          style="width: 100%; height: 100%"
          v-show="itemIndex == 2"
          :src="`${ossBaseUrl}/swipe.png`"
        />
      </div>
      <div class="more">
        <a href="https://909th.com/works">了解更多</a>
      </div>
      <h2>
        <img
          class="greendot"
          :src="`${ossBaseUrl}/greendot_left.png`"
          alt=""
        />热门设计<img
          class="greendot"
          :src="`${ossBaseUrl}/greendot_right.png`"
          alt=""
        />
      </h2>

      <div class="hot flex" :style="{ width: isMobile ? '100%' : '' }">
        <div>
          <div
            class="tabHot"
            :class="{ activeHot: hotIndex == item.index }"
            v-for="(item, index) in hotTab"
            :key="index"
            @click="switchHotTab(item.index)"
          >
            <div>{{ item.title }}</div>
          </div>
        </div>
        <div class="rightContent" :style="{ width: isMobile ? '100%' : '' }">
          <img
            style="width: 100%; height: 100%"
            v-show="hotIndex == 1"
            :src="`${ossBaseUrl}/tab1.jpg`"
          />
          <img
            style="width: 100%; height: 100%"
            v-show="hotIndex == 2"
            :src="`${ossBaseUrl}/tab2.jpg`"
          />
          <img
            style="width: 100%; height: 100%"
            v-show="hotIndex == 3"
            :src="`${ossBaseUrl}/tab3.jpg`"
          />
          <img
            style="width: 100%; height: 100%"
            v-show="hotIndex == 4"
            :src="`${ossBaseUrl}/tab4.jpg`"
          />
          <img
            style="width: 100%; height: 100%"
            v-show="hotIndex == 5"
            :src="`${ossBaseUrl}/tab5.jpg`"
          />
          <img
            style="width: 100%; height: 100%"
            v-show="hotIndex == 6"
            :src="`${ossBaseUrl}/tab6.jpg`"
          />
          <img
            style="width: 100%; height: 100%"
            v-show="hotIndex == 7"
            :src="`${ossBaseUrl}/tab7.jpg`"
          />
        </div>
      </div>
      <div class="more"><a href="https://909th.com/works">了解更多</a></div>
    </div>
    <div class="morelink">
      <div class="morelink-link" :style="{ width: isMobile ? '100%' : '' }">
        <h3>已服务过<span>500</span>多家大型企业</h3>
        <img :src="`${ossBaseUrl}/logos.png`" style="width: 100%" />
      </div>
    </div>
    <div class="process">
      <h2>
        <img
          class="greendot"
          :src="`${ossBaseUrl}/greendot_left.png`"
          alt=""
        />合作流程<img
          class="greendot"
          :src="`${ossBaseUrl}/greendot_right.png`"
          alt=""
        />
      </h2>
      <div class="process_table" :style="{ width: isMobile ? '100%' : '' }">
        <div class="process_tr flex">
          <div class="process_td">
            <img
              :src="`${ossBaseUrl}/icon21.png`"
              style="width: auto; height: 10rem"
              alt=""
            />
            <h3>填需求表</h3>
            <h3>协商细节</h3>
          </div>
          <div class="process_td02">
            <img
              :src="`${ossBaseUrl}/arrow_green.png`"
              style="width: 2.5rem; height: 2.5rem; left: -7.6rem; top: 5.8rem"
              alt=""
            />
            <img
              :src="`${ossBaseUrl}/icon22.png`"
              style="width: auto; height: 10rem; margin-left: -1.7rem"
              alt=""
            />
            <h3>签订协议</h3>
            <h3>预付70%费用</h3>
          </div>
          <div class="process_td">
            <img
              :src="`${ossBaseUrl}/arrow_dark.png`"
              style="width: 2.5rem; height: 2.5rem; left: -8.2rem; top: 5.8rem"
              alt=""
            />
            <img
              :src="`${ossBaseUrl}/icon23.png`"
              style="width: auto; height: 10rem; margin-left: -1.7rem"
              alt=""
            />
            <h3>验收草图</h3>
            <h3>反馈意见</h3>
          </div>
          <div class="process_td02">
            <img
              :src="`${ossBaseUrl}/arrow_green.png`"
              style="width: 2.5rem; height: 2.5rem; left: -7.3rem; top: 5.8rem"
              alt=""
            />
            <img
              :src="`${ossBaseUrl}/icon24.png`"
              style="width: auto; height: 10rem; margin-left: -1.7rem"
              alt=""
            />
            <h3>验收终稿</h3>
            <h3>支付尾款</h3>
          </div>
        </div>
      </div>
    </div>

    <div class="connect">
      <div class="links_items" :style="{ width: isMobile ? '100%' : '' }">
        <div class="lefts">
          <div>
            <h2>沟通无障碍-认真接待每位咨询者</h2>
            <p>支持电话、微信、视频会议等沟通方式</p>
          </div>
          <div class="items">
            <div class="qrText">了解合作细节</div>
            <div class="qrText right">
              请扫右侧二维码
              <img :src="`${ossBaseUrl}/arrow.png`" alt="" />
            </div>
          </div>
        </div>
        <div class="rights">
          <div class="">
            <!-- connectRight -->
            <img
              :src="`${ossBaseUrl}/qrcode.png`"
              style="width: 20rem; height: 20rem"
              alt=""
            />
          </div>
          <div class="textAdd">欢迎扫码添加好友咨询</div>
        </div>
      </div>

      <div class="connectBottom" style="">
        <div style="margin-top: 6rem; line-height: 6rem">
          <div>
            <img
              :src="`${ossBaseUrl}/icon30.jpg`"
              style="
                width: 5rem;
                height: 3.5rem;
                vertical-align: middle;
                margin-right: 1.5rem;
              "
              alt=""
            />
            <span style="font-size: 2.5rem">18061610919</span>
          </div>
          <div>
            <img
              :src="`${ossBaseUrl}/icon31.jpg`"
              alt=""
              style="
                width: 5.5rem;
                height: 3rem;
                vertical-align: middle;
                margin-right: 1.2rem;
              "
            />
            <span style="font-size: 2.5rem">koala@909th.com</span>
          </div>
          <!-- zzhou@9thws.com -->
        </div>
        <div class="connectBg">
          <img :src="`${ossBaseUrl}/illus_bottom.png`" style="" /><!-- bg.jpg -->
        </div>
      </div>
    </div>

    <div class="qr">
      <div
        class="close_box"
        style="position: absolute; top: 0.1rem; right: 0.1rem"
        @click="toggleKefu"
      >
        <img :src="`${ossBaseUrl}/close.png`" style="width: 2rem; height: 2rem" />
      </div>
      <div class="kefu_box" v-if="show_kefu == true">
        <div>
          <img :src="`${ossBaseUrl}/kefu_bg.png`" style="width: 19rem; height: 32rem" />
        </div>
        <div class="name" style="position: relative; top: -9.6rem">
          第九工场-考拉
        </div>
        <div
          style="
            position: relative;
            top: -10.1rem;
            font-size: 1.6rem;
            margin-left: 6.4rem;
            font-weight: 520;
            color: #805e4e;
          "
        >
          商务经理
        </div>
        <!-- class="position" -->
      </div>
    </div>

    <div class="foot_bar">
      <div class="titles">
        来不及找到心仪的内容? 按<span class="btn">Ctrl</span>+<span class="btn"
          >D</span
        >收藏我们
      </div>
    </div>

    <div class="foot_box">
      <div class="foot_link">
        <div class="lefts">
          <div class="title">关于我们</div>
          <div style="font-size: 1.2rem">
            第九工场上线于2015年,
            从最初单一的艺术二维码模板交易平台发展至今成为：艺术二维码模板交易、设计定制服务、
          </div>
          <div style="font-size: 1.2rem">设计交易培训为一体的设计机构</div>
        </div>
        <div class="qrcodes">
          <div class="qr1">
            <img :src="`${ossBaseUrl}s/footer/qrcode.png`" />
            <div class="txt">关注我, 学技巧</div>
          </div>
          <div class="qr2">
            <img :src="`${ossBaseUrl}s/footer/qrcode_99.png`" />
            <div class="txt">有问题, 找九九</div>
          </div>
        </div>
      </div>
      <div
        style="
          padding-left: 36rem;
          width: 108rem;
          margin: 0 auto;
          padding: 2rem 4rem 0rem 1.6rem;
        "
      >
        <hr align="left" width="100%" color="#59DDDC" SIZE="1" style="width: 100%; margin: 0" />
      </div>
      <div class="copyrights">
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">苏ICP备15061928号-4 版权所有：南京良码信息科技有限公司</a>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import {ossBaseUrl} from "@/main";
export default {
  components: {
    Header,
  },
  props: {
    isMobile: Boolean,
  },
  data() {
    return {
      ossBaseUrl,
      show_kefu: true,
      hotIndex: 1,
      itemIndex: 1,
      featureTab: [
        { index: 1, title: "艺术二维码设计" },
        { index: 2, title: "设计师远程包月" },
      ],
      hotTab: [
        { index: 1, title: "商业插画" },
        { index: 2, title: "卡通形象" },
        { index: 3, title: "海报设计" },
        { index: 4, title: "界面设计" },
        { index: 5, title: "视频制作" },
        { index: 6, title: "文章排版" },
        { index: 7, title: "三维设计" },
      ],
      keyObj: { Control: -1, d: -1 },
    };
  },
  mouted() {
    document.onkeydown = (e) => {
      // ctrl   keyCode ==> 17  |  D  d keyCode ==> 68
      // 用户按下 ctrl 17
      const { keyCode } = e;
      // console.log('keyCode ===>', keyCode);
      if (keyCode === 17) {
        this.keyObj.Control = 17;
      } else if (keyCode === 68 && this.keyObj.Control === 17) {
        this.keyObj.d = 68;
      }
    };
    document.onkeyup = (e) => {
      const { keyCode } = e;
      if (keyCode === 17) {
        this.keyObj = { Control: -1, d: -1 };
      }
    };
  },
  watch: {
    keyObj: {
      handler: function (obj) {
        this.ctrl$dHandler(obj);
      },
      deep: true,
    },
  },
  methods: {
    ctrl$dHandler(obj) {
      const { Control, d } = obj;
      if (Control === 17 && d === 68) {
        // alert('用户按下了 ctrl + d, #######')
        console.log("用户按下了 ctrl + d, #######");
      }
    },
    toggleKefu() {
      this.show_kefu = !this.show_kefu;
    },
    switchHotTab(index) {
      this.hotIndex = index;
    },
    switchFeatureTab(index) {
      this.itemIndex = index;
    },
  },
};
</script>
<style lang="less" scoped>
.layouts-container {
  width: 100%; /* min-width: 1280px; */
}
.flex {
  display: box; /* OLD - Android 4.4- */
  display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
  display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
  display: -ms-flexbox; /* TWEENER - IE 10 */
  display: -webkit-flex; /* NEW - Chrome */
  display: flex; /* NEW, Spec - Opera 12.1, Firefox 20+ */
}
.banner {
  position: relative;
  overflow: hidden;
  height: 84rem;
}
.banner-title {
  position: absolute;
  text-align: center;
  top: 40%;
  width: 100%; /* left: 36%; */
  z-index: 99;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
.banner-title h1 {
  color: #76d3cf;
  font-size: 8rem;
  line-height: 5rem;
}
.banner-title p {
  color: #f2f2f2;
  font-size: 4rem;
}
.todowns {
  position: absolute;
  text-align: center;
  top: 85%;
  width: 100%;
  z-index: 99;
}
.todowns img {
  width: 3rem;
  height: 2rem;
  cursor: pointer;
}
.overlay {
  position: relative;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.images {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 300%;
  animation: banner 40s linear infinite;
  background-size: auto 100%;
}
@keyframes banner {
  0% {
    left: 0;
  }
  100% {
    left: -200%;
  }
}
.greendot {
  transform: scale(0.5);
}
.textAdd {
  position: absolute;
  left: 50%;
  bottom: -4rem;
  width: 150%;
  transform: translateX(-50%);
  font-size: 2rem;
  text-align: center;
  color: #fff;
  background-color: #0d282c !important;
}
.position {
  margin-left: 5rem;
  text-align: center;
  width: 10rem;
  font-size: 1.6rem;
  font-weight: 520;
  border-radius: 2rem;
  padding: 0.6rem;
  background-image: linear-gradient(to right, #f2dec9, #dfbe9f);
}
.name {
  width: 100%;
  text-align: center;
  line-height: 4rem;
  font-weight: 600;
  font-size: 1.6rem;
  margin-top: 1rem;
}
.add {
  margin-top: 1rem;
  width: 15rem;
  text-align: center;
  margin-left: calc(50% - 7.5rem);
  font-size: 1.6rem;
}
.add .txt1 {
  color: #b09a8c;
}
.add .txt2 {
  color: #dbbca3;
}
.hello {
  margin-top: 1rem;
  text-align: center;
  color: #76d3cf;
  font-size: 2.4rem;
  font-weight: 700;
}
.qrImg {
  margin-top: 1rem;
  margin-left: calc(50% - 5rem);
  width: 10rem;
  height: 10rem;
  background-color: #fff;
}
.weightText {
  margin-bottom: 5rem !important;
}
.text {
  margin-top: 1rem;
  line-height: 8rem;
  color: #fff;
  font-size: 2.4rem;
}
.right {
  position: relative;
  margin-left: -8rem;
  text-align: center !important;
  color: #000 !important;
  background-color: #fff !important;
}

.qrText {
  padding-left: 2rem;
  border-radius: 8rem;
  font-weight: 800;
  width: 25rem;
  font-size: 2rem;
  line-height: 6rem;
  color: #fff;
  text-align: left;
  border: 0.1rem solid #eee;
  background-color: #0d282c;
}
.qrText.right > img {
  width: 2.3rem;
  height: 2.2rem;
  margin-left: 0.5rem;
  margin-top: -0.4rem;
  vertical-align: middle;
}
.connectTop {
  position: absolute;
  top: 11rem;
  left: 10%;
  width: 67rem;
  height: 13rem;
}
.connectTop h2 {
  font-size: 3.4rem;
  color: #76d3cf;
  line-height: 4rem;
}
.connectTop p {
  font-size: 2.7rem;
  color: #f2f2f2;
}

.connectLeft {
  margin: 27rem 15.5rem; /*left: 10%;  margin-left: calc(50% - 520px); */
}
.connectLeft .items {
  display: flex;
  width: 50rem;
  height: 6rem;
}

.connectRight {
  margin-left: 35rem;
  margin-top: 12rem;
  width: 20rem;
  height: 20rem;
  background-color: #fff;
}

.bottom {
  width: 100%;
  height: 20rem;
  background-color: #76d3cf;
}

.qr {
  position: fixed;
  top: 10rem;
  right: 5rem;
  z-index: 10;
}

.more {
  margin-bottom: 8rem;
  margin-left: calc(50% - 20rem);
  width: 40rem;
  margin-top: 8rem;
  height: 8rem;
  font-size: 2.4rem;
  text-align: center;
  line-height: 8rem;
  font-weight: 800;
  letter-spacing: 0.2rem;
  color: #000;
  border: 0.2rem solid #0d282c;
  display: flex;
  align-items: center;
  justify-content: center;
}

.more a {
  color: #0d282c;
}

.activeHot {
  background-color: #76d3cf !important;
}

.tabHot {
  width: 22rem;
  height: 10rem;
  font-size: 2.8rem;
  background-color: #0d282c;
  border-bottom: 0.1rem solid #fff;
  border-right: 0.1rem solid #fff;
  text-align: center;
  color: #fff;
  line-height: 10rem;
  cursor: pointer;
}

.rightContent {
  width: 88rem;
  height: 70rem; /* background-color: #7e9ca0; */
}

.hot {
  display: flex;
  width: 108rem;
  height: 70rem;
  background-color: #76d3cf;
  margin: 0 auto; /* margin-left: calc(50% - 55rem) */
}

.active {
  background-color: #76d3cf !important;
  z-index: 99999;
}

.tabImg {
  /* margin-top: 5rem; */
  width: 108rem;
  background-color: #0d282c;
  margin: 5rem auto; /* margin-left: calc(50% - 55rem) */
}

.tab {
  font-size: 2.6rem;
  width: 40rem;
  height: 8rem;
  position: relative;
  margin-left: -6rem;
  border-radius: 8rem;
  background-color: #0d282c;
  text-align: center;
  color: #fff;
  line-height: 8rem;
  cursor: pointer;
}

.switch {
  width: 100%;
  margin-left: calc(50% - 34rem);
  display: flex;
}

.ant-carousel :deep(.slick-slide) {
  height: 83rem;
  line-height: 83rem;
  overflow: hidden;
}

.ant-carousel :deep(.slick-slide h3) {
  color: #fff;
}

.teamwork {
  background: #0d282c;
  height: 85rem;
  padding-top: 9rem;
}

.teamwork-more {
  width: 108rem;
  height: 32.8rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
/* .teamwork-more tr { display: flex; justify-content: space-around; } */
.teamwork-more td,
.more_td {
  /* width: 35.3rem; */
  width: 32%;
  height: 36rem;
  background-color: #76d3cf;
  text-align: center;
  padding-top: 7rem; /* position: relative; left: 0; bottom: -4rem; */
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.teamwork-more td,
.more_td .img02 {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%) scale(0.5) translateY(-50%);
}
.teamwork-more td,
.more_td .icon {
  width: 13rem;
  height: 13rem;
  margin-bottom: 1.5rem;
}
.teamwork-more td,
.more_td h4 {
  font-size: 3rem;
  font-weight: bold;
}

.teamwork-more td,
.more_td p {
  font-size: 1.8rem;
  font-weight: 540;
  line-height: 1rem;
}

.teamwork .table1 {
  display: flex;
  justify-content: center;
  padding-top: 5rem;
  width: 108rem;
  margin: 0 auto;
}

.teamwork .table1 p {
  text-align: center;
  color: #f2f2f2;
  line-height: 7rem;
  font-size: 2rem;
}

.teamwork h3 {
  text-align: center;
  color: #f2f2f2;
  font-size: 2.2rem;
}

.teamwork h2 {
  text-align: center;
  font-size: 5.8rem;
  font-weight: 800;
  color: #76d3cf;
}

.teamwork h2 img {
  padding: 0 3rem 0;
}

.design {
  background: #f2f2f2;
  height: 242rem;
  padding-top: 28rem;
}

.design h2 {
  text-align: center;
  font-size: 5.8rem;
  font-weight: 800;
}

.design h2 img {
  padding: 0 3rem 0;
}

.morelink {
  background: #0d282c;
  height: 70rem;
}

.morelink-link {
  margin: 0 auto;
  width: 108rem;
  padding: 5.1rem 1rem 5.1rem 1rem;
}

.morelink-link h3 {
  text-align: center;
  font-size: 5rem;
  color: #76d3cf;
  font-weight: 20;
}

.morelink-link h3 span {
  text-align: center;
  font-size: 5.4rem;
  line-height: 12rem;
  color: #76d3cf;
  font-style: italic;
  font-weight: 600;
}

.morelink-link table {
  width: 100%;
  height: 45rem;
}

.morelink-link table td {
  text-align: center;
}

.process {
  /* height: 46rem; */
  background: #f2f2f2;
  padding-top: 6.5rem;
  padding-bottom: 6.2rem;
}

.process h2 {
  text-align: center;
  font-size: 5.8rem;
  font-weight: 800;
}

.process h2 img {
  padding: 0 3rem 0;
}

.process table,
.process_table {
  width: 108rem;
  margin: 5rem auto;
}

.process table tr {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
}
.process .process_table .process_tr {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
}
.process td,
.process_td,
.process_td02 {
  width: 23.5rem;
  height: 20.5rem;
  background-color: #76d3cf;
  text-align: center;
  border-radius: 1rem;
  margin-left: 1rem;
}

.process .td02,
.process_td02 {
  background-color: #0d282c;
}

.process td h3 {
  font-size: 3rem;
  font-weight: 550;
  color: #f2f2f2;
  line-height: 2rem;
}
.process .process_td h3 {
  font-size: 3rem;
  font-weight: 550;
  color: #f2f2f2;
  line-height: 2rem;
}
.process .process_td02 h3 {
  font-size: 3rem;
  font-weight: 550;
  color: #f2f2f2;
  line-height: 2rem;
}
.process td img {
  position: relative;
  top: -3.5rem;
}
.process .process_td img {
  position: relative;
  top: -3.5rem;
}
.process .process_td02 img {
  position: relative;
  top: -3.5rem;
}

.connect {
  background: #0d282c;
  display: flex;
  flex-direction: column;
  /* background: #0d282c url(../image/bg.jpg) no-repeat 65% 100%; */
}

.connect .links_items {
  display: flex;
  justify-content: space-between;
  width: 108rem;
  margin: 0rem auto;
  padding: 10rem 8rem 1rem; /* margin: 50px 360px 50px 360px; */
}
.connect .links_items h2 {
  font-size: 3.4rem;
  color: #76d3cf;
  line-height: 4rem;
}
.connect .links_items p {
  font-size: 2.7rem;
  color: #f2f2f2;
  margin-top: 2rem;
}
.connect .links_items .lefts .items {
  display: flex;
  width: 50rem;
  height: 6rem;
  margin-top: 4rem;
}

.connect .links_items .rights {
  height: 20rem;
  position: relative;
}
.connectBottom {
  display: flex;
  justify-content: space-between;
  width: 108rem;
  margin: 3rem auto 0;
  font-size: 2rem;
  color: #f2f2f2;
  line-height: 4rem;
  padding: 5rem 2rem 0 1.6rem;
}
.connectBg {
  margin-top: auto;
  /* position: absolute;top: 365px; right: 13%; */
}
.connectBg img {
  width: 36rem;
  height: 29.3rem;
  margin-left: 2rem;
}
.foot_bar {
  background: #32d6d6;
  height: 6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 1.4rem;
}
.foot_bar .icons {
  position: relative;
  left: 15rem;
  top: -5.3rem;
}
.foot_bar .icons img {
  width: 4.5rem;
  height: 2.8rem;
}
.foot_bar .titles {
}
.foot_bar .titles .btn {
  background-color: #ffd666;
  font-size: 1.6rem;
  padding: 0.2rem 0.8rem;
  margin: 0 0.5rem;
  border-radius: 0.5rem;
}

.foot_box {
  display: flex;
  flex-direction: column;
  background: #02cacb;
  //height: 30rem;
}
.foot_box .foot_link {
  display: flex;
  justify-content: space-between;
  width: 108rem;
  margin: 0 auto 3rem;
  padding: 2rem 4rem 1rem 1.6rem; /* padding: 20px 360px 20px 360px; */
}
.foot_link .lefts {
  color: #fff;
  font-size: 1rem;
  display: flex;
  flex-direction: column;
}
.foot_link .lefts .title {
  font-size: 1.4rem;
  margin-bottom: 0.8rem;
}
.foot_link .qrcodes {
  display: flex;
}
.foot_link .qrcodes .qr1 {
}
.foot_link .qrcodes img {
  width: 10rem;
  height: 10rem;
}
.foot_link .qrcodes .qr1 img {
  margin-right: 1rem;
}
.foot_link .txt {
  font-size: 1.2rem;
  color: #fff;
  text-align: center;
  margin-top: 1rem;
}
.foot_box .copyrights {
  color: #fff;
  font-size: 1.3rem;
  width: 108rem;
  margin: 0 auto;
  padding: 1.6rem 1rem 1.6rem 1rem; /* padding: 10px 49px 10px 360px; */
  a {
    color: hsla(0,0%,100%,.7);
  }
}
</style>
